import * as React from 'react';
import { FC } from 'react';

import {
  PointsContainer,
  PointsTextContainer,
  StyledPointsIcon,
  StyledRewardLockIcon,
  StyledRewardPointCost,
} from './incentive-details.styled';
import { IRewardPoints } from './types';

export const RewardPoints: FC<React.PropsWithChildren<IRewardPoints>> = ({ pointCost, locked }) => {
  return (
    <PointsContainer marginTop={'$0'}>
      <PointsTextContainer marginBottom={'$4'}>
        {locked ? <StyledRewardLockIcon /> : <StyledPointsIcon />}
        <StyledRewardPointCost pointCost={pointCost} fontSize="md">
          {pointCost}
        </StyledRewardPointCost>
      </PointsTextContainer>
    </PointsContainer>
  );
};
